// This file is auto-generated by @hey-api/openapi-ts

import type {
  Client,
  ClientMeta,
  Options as Options2,
  RequestResult,
  ServerSentEventsResult,
  TDataShape
} from './client'
import { client } from './client.gen'
import type {
  AccessTokenData,
  AccessTokenErrors,
  AccessTokenResponses,
  AddCollectionToCartData,
  AddCollectionToCartErrors,
  AddCollectionToCartResponses,
  AddOrderToCartData,
  AddOrderToCartErrors,
  AddOrderToCartResponses,
  AddQuoteLineItemData,
  AddQuoteLineItemErrors,
  AddQuoteLineItemResponses,
  AddToCollectionData,
  AddToCollectionErrors,
  AddToCollectionResponses,
  ApproveOrderData,
  ApproveOrderErrors,
  ArchiveCollectionData,
  ArchiveCollectionErrors,
  ArchiveCollectionResponses,
  ArchiveQuoteData,
  ArchiveQuoteErrors,
  ArchiveQuoteResponses,
  BrandingData,
  BrandingErrors,
  BrandingResponses,
  CategoryTreeData,
  CategoryTreeErrors,
  CategoryTreeResponses,
  ChangePasswordData,
  ChangePasswordErrors,
  ChangePasswordResponses,
  CountLineItemsData,
  CountLineItemsErrors,
  CountLineItemsResponses,
  CountNewQuotesData,
  CountNewQuotesErrors,
  CountNewQuotesResponses,
  CreateAddressData,
  CreateAddressErrors,
  CreateCollectionData,
  CreateCollectionErrors,
  CreateCollectionResponses,
  CreateLineItemData,
  CreateLineItemErrors,
  CreateLineItemResponses,
  CreateLoginNetgoUserData,
  CreateLoginNetgoUserErrors,
  CreateLoginNetgoUserResponses,
  CreateOrderRmaData,
  CreateOrderRmaErrors,
  CreateQuoteRequestData,
  CreateQuoteRequestErrors,
  CreateQuoteRequestResponses,
  DearchiveCollectionData,
  DearchiveCollectionErrors,
  DearchiveCollectionResponses,
  DearchiveQuoteData,
  DearchiveQuoteErrors,
  DearchiveQuoteResponses,
  DeleteAddressData,
  DeleteAddressErrors,
  DeleteCollectionData,
  DeleteCollectionErrors,
  DeleteCollectionResponses,
  DeleteLineItem1Data,
  DeleteLineItem1Errors,
  DeleteLineItem2Data,
  DeleteLineItem2Errors,
  DeleteLineItemData,
  DeleteLineItemErrors,
  DeleteOrderItemData,
  DeleteOrderItemErrors,
  DeletePreparedOrderData,
  DeletePreparedOrderErrors,
  DeletePreparedOrderResponses,
  DeleteQuoteRequestData,
  DeleteQuoteRequestErrors,
  DeleteQuoteRequestResponses,
  DeleteUserData,
  DeleteUserErrors,
  DuplicateCollectionData,
  DuplicateCollectionErrors,
  DuplicateCollectionResponses,
  EmptyCartData,
  EmptyCartErrors,
  EmptyCartResponses,
  FeaturedData,
  FeaturedErrors,
  FeaturedResponses,
  FilterNodesData,
  FilterNodesErrors,
  FilterNodesResponses,
  GetActivityData,
  GetActivityErrors,
  GetActivitySseData,
  GetActivitySseErrors,
  GetApprovableOrdersData,
  GetApprovableOrdersErrors,
  GetApprovableOrdersFilterNodesData,
  GetApprovableOrdersFilterNodesErrors,
  GetApprovableOrdersFilterNodesResponses,
  GetApprovableOrdersResponses,
  GetCheckoutByIdData,
  GetCheckoutByIdErrors,
  GetCheckoutByIdResponses,
  GetCheckoutData,
  GetCheckoutErrors,
  GetCheckoutForQuoteData,
  GetCheckoutForQuoteErrors,
  GetCheckoutForQuoteResponses,
  GetCheckoutResponses,
  GetCheckoutTermsData,
  GetCheckoutTermsErrors,
  GetCheckoutTermsResponses,
  GetCollectionData,
  GetCollectionErrors,
  GetCollectionFiltersData,
  GetCollectionFiltersErrors,
  GetCollectionFiltersResponses,
  GetCollectionResponses,
  GetCollectionsData,
  GetCollectionsErrors,
  GetCollectionsResponses,
  GetComparisonData,
  GetComparisonErrors,
  GetCurrentUserData,
  GetCurrentUserErrors,
  GetCurrentUserResponses,
  GetCustomTermsData,
  GetCustomTermsErrors,
  GetCustomTermsResponses,
  GetDataHtmlDatasheet1Data,
  GetDataHtmlDatasheet1Errors,
  GetDataHtmlDatasheet2Data,
  GetDataHtmlDatasheet2Errors,
  GetDataHtmlDatasheet3Data,
  GetDataHtmlDatasheet3Errors,
  GetDataHtmlDatasheetData,
  GetDataHtmlDatasheetErrors,
  GetEmployeeByIdData,
  GetEmployeeByIdErrors,
  GetFilterNodesData,
  GetFilterNodesErrors,
  GetFilterNodesResponses,
  GetFiltersData,
  GetFiltersErrors,
  GetIsProductInQuoteRequestData,
  GetIsProductInQuoteRequestErrors,
  GetIsProductInQuoteRequestResponses,
  GetModelGroupsData,
  GetModelGroupsErrors,
  GetModelGroupsResponses,
  GetMoveInfoData,
  GetMoveInfoErrors,
  GetMoveInfoResponses,
  GetOptimizationData,
  GetOptimizationErrors,
  GetOptimizationResponses,
  GetOptimizationsData,
  GetOptimizationsErrors,
  GetOptimizationsResponses,
  GetOrderData,
  GetOrderErrors,
  GetOrderPreviewsData,
  GetOrderPreviewsErrors,
  GetOrderPreviewsResponses,
  GetOrderRmaData,
  GetOrderRmaErrors,
  GetOrdersData,
  GetOrdersErrors,
  GetOrdersResponses,
  GetProductClassData,
  GetProductClassErrors,
  GetProductClassesData,
  GetProductClassesErrors,
  GetProductClassesResponses,
  GetProductClassResponses,
  GetProductInformationData,
  GetProductInformationErrors,
  GetProductInformationResponses,
  GetProductRequestMailData,
  GetProductRequestMailErrors,
  GetProductRequestMailResponses,
  GetQuoteRequestData,
  GetQuoteRequestErrors,
  GetQuoteRequestForProductData,
  GetQuoteRequestForProductErrors,
  GetQuoteRequestForProductResponses,
  GetQuoteRequestResponses,
  GetSendCollectionMailData,
  GetSendCollectionMailErrors,
  GetSendCollectionMailResponses,
  GetTransactionHistory1Data,
  GetTransactionHistory1Errors,
  GetTransactionHistory1Responses,
  GetTransactionHistoryData,
  GetTransactionHistoryErrors,
  GetTransactionHistoryResponses,
  ImpersonationStatusData,
  ImpersonationStatusErrors,
  ImpersonationStatusResponses,
  InitiatePasswordResetData,
  InitiatePasswordResetErrors,
  InitiatePasswordResetResponses,
  InviteColleaguesData,
  InviteColleaguesErrors,
  InviteColleaguesResponses,
  InviteYourselfData,
  InviteYourselfErrors,
  InviteYourselfResponses,
  LoadAccessoriesForProductData,
  LoadAccessoriesForProductErrors,
  LoadBundleItemsForProductData,
  LoadBundleItemsForProductErrors,
  LoadFullProductData,
  LoadFullProductErrors,
  LoadFullProductResponses,
  LoadQuoteByIdData,
  LoadQuoteByIdErrors,
  LoadQuoteByIdSseData,
  LoadQuoteByIdSseErrors,
  LoadQuotesData,
  LoadQuotesErrors,
  LoadQuotesResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  MoveLineItemData,
  MoveLineItemErrors,
  OptimizeCartData,
  OptimizeCartErrors,
  OptimizeCartResponses,
  PatchOrderItemData,
  PatchOrderItemErrors,
  PostActivityData,
  PostActivityErrors,
  PrintQuoteData,
  PrintQuoteErrors,
  ReadAddressesData,
  ReadAddressesErrors,
  ReadAddressesResponses,
  ReadApproversData,
  ReadApproversErrors,
  ReadApproversResponses,
  ReadCompanyOrderLimitData,
  ReadCompanyOrderLimitErrors,
  ReadCompanyOrderLimitResponses,
  ReadEmployeesData,
  ReadEmployeesErrors,
  ReadLineItemsData,
  ReadLineItemsErrors,
  ReadLineItemsResponses,
  ReadOrderLimitUsersData,
  ReadOrderLimitUsersErrors,
  ReadOrderLimitUsersResponses,
  ReadSupplierCartData,
  ReadSupplierCartErrors,
  ReadSupplierCartResponses,
  RegisterInvitedUserData,
  RegisterInvitedUserErrors,
  RegisterInvitedUserResponses,
  RejectOrderData,
  RejectOrderErrors,
  RejectQuoteData,
  RejectQuoteErrors,
  RequestCartData,
  RequestCartErrors,
  RequestOrderByIdData,
  RequestOrderByIdErrors,
  RequestQuote1Data,
  RequestQuote1Errors,
  RequestQuote1Responses,
  RequestQuote2Data,
  RequestQuote2Errors,
  RequestQuote2Responses,
  RequestQuoteData,
  RequestQuoteErrors,
  RuntimePriceData,
  RuntimePriceErrors,
  RuntimePriceResponses,
  RuntimePricesData,
  RuntimePricesErrors,
  RuntimePricesResponses,
  SearchForOrdersData,
  SearchForOrdersErrors,
  SearchForOrdersResponses,
  SearchForSubsidiariesData,
  SearchForSubsidiariesErrors,
  SearchForSubsidiariesResponses,
  SearchProductData,
  SearchProductErrors,
  SearchProductResponses,
  SearchProductSliceData,
  SearchProductSliceErrors,
  SearchProductSliceResponses,
  SelfRegisterData,
  SelfRegisterErrors,
  SelfRegisterResponses,
  SendCartData,
  SendCartEprocurementData,
  SendCartEprocurementErrors,
  SendCartErrors,
  SendCartTopiData,
  SendCartTopiErrors,
  SendCartTopiResponses,
  SendCollectionMailData,
  SendCollectionMailErrors,
  SendCollectionMailResponses,
  SendProductRequestMailData,
  SendProductRequestMailErrors,
  SendProductRequestMailResponses,
  SendQuoteData,
  SendQuoteEprocurementData,
  SendQuoteEprocurementErrors,
  SendQuoteErrors,
  SendQuoteRequestData,
  SendQuoteRequestErrors,
  SendQuoteRequestResponses,
  SettingsData,
  SettingsErrors,
  SettingsResponses,
  SubsidiariesData,
  SubsidiariesErrors,
  SubsidiariesResponses,
  SwitchToSubsidiaryData,
  SwitchToSubsidiaryErrors,
  SwitchToSubsidiaryResponses,
  UpdateAddressData,
  UpdateAddressErrors,
  UpdateCollectionData,
  UpdateCollectionErrors,
  UpdateCompanyOrderLimitData,
  UpdateCompanyOrderLimitErrors,
  UpdateCompanyOrderLimitResponses,
  UpdateLineItem1Data,
  UpdateLineItem1Errors,
  UpdateLineItem2Data,
  UpdateLineItem2Errors,
  UpdateLineItem2Responses,
  UpdateLineItemData,
  UpdateLineItemErrors,
  UpdateOrderData,
  UpdateOrderErrors,
  UpdateOrderLimitUserData,
  UpdateOrderLimitUserErrors,
  UpdateOrderLimitUserResponses,
  UpdateQuoteData,
  UpdateQuoteErrors,
  UpdateQuoteItemData,
  UpdateQuoteItemErrors,
  UpdateQuoteRequestData,
  UpdateQuoteRequestErrors,
  UpdateQuoteRequestResponses,
  UpdateTopiOrderData,
  UpdateTopiOrderErrors,
  UpdateUserCredentialsData,
  UpdateUserCredentialsErrors,
  UpdateUserData,
  UpdateUserErrors,
  UpdateUserPermissionsData,
  UpdateUserPermissionsErrors,
  UpdateUserSettingsData,
  UpdateUserSettingsErrors,
  UpdateUserSettingsResponses,
  UploadAvatarData,
  UploadAvatarErrors,
  ValidateAddressCheckoutData,
  ValidateAddressCheckoutErrors,
  ValidateAddressCheckoutResponses,
  ValidateEmails1Data,
  ValidateEmails1Errors,
  ValidateEmails1Responses,
  ValidateEmailsData,
  ValidateEmailsErrors,
  ValidateEmailsResponses,
  ValidateOrderNumberData,
  ValidateOrderNumberErrors,
  ValidateOrderNumberResponses,
  ValidatePasswordChangeTokenData,
  ValidatePasswordChangeTokenErrors,
  ValidatePasswordChangeTokenResponses,
  ValidateRegisterTokenData,
  ValidateRegisterTokenErrors,
  ValidateRegisterTokenResponses
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta
}

/**
 * Update user avatar
 *
 * Update the avatar of the user identified by the id provided as path variable.Allowed image types: bmp, gif, jpeg, png, tiff. Returns the id of avatar.
 */
export const uploadAvatar = <ThrowOnError extends boolean = false>(
  options: Options<UploadAvatarData, ThrowOnError>
): RequestResult<unknown, UploadAvatarErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, UploadAvatarErrors, ThrowOnError>({
    url: '/storefront/user/{id}/avatar',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Validate password-reset token.
 *
 * If the response to this action is 200 OK the token is valid. The token necessary for this validation can be retrieved from the initiate password reset action. This action enables token validation e.g. before the user is directed to the password reset page. Returns the used token.
 */
export const validatePasswordChangeToken = <ThrowOnError extends boolean = false>(
  options: Options<ValidatePasswordChangeTokenData, ThrowOnError>
): RequestResult<
  ValidatePasswordChangeTokenResponses,
  ValidatePasswordChangeTokenErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ValidatePasswordChangeTokenResponses,
    ValidatePasswordChangeTokenErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/user/actions/validate-password-token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Initiate password reset
 *
 * This is the first step in the process of resetting a password. When an user account exits for the requested email, an email is sent to the user. This mail contains a link to the password reset page. The link contains a token that has to be included in the further steps of this process. The second step in this process is validating is to validate the token before allowing the user to access the password change page. Returns the requested email address.
 */
export const initiatePasswordReset = <ThrowOnError extends boolean = false>(
  options: Options<InitiatePasswordResetData, ThrowOnError>
): RequestResult<InitiatePasswordResetResponses, InitiatePasswordResetErrors, ThrowOnError> =>
  (options.client ?? client).post<
    InitiatePasswordResetResponses,
    InitiatePasswordResetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/user/actions/reset-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const createLoginNetgoUser = <ThrowOnError extends boolean = false>(
  options: Options<CreateLoginNetgoUserData, ThrowOnError>
): RequestResult<CreateLoginNetgoUserResponses, CreateLoginNetgoUserErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateLoginNetgoUserResponses,
    CreateLoginNetgoUserErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/user/actions/netgo-login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Change password
 *
 * Change the password of the user identified by the provided token. The token necessary for this action can be received from the initiate password reset action. Before allowing a user to change their password, the token can be validated via the Validate password-change token action. Returns the used token.
 */
export const changePassword = <ThrowOnError extends boolean = false>(
  options: Options<ChangePasswordData, ThrowOnError>
): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> =>
  (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/user/actions/change-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Load runtime prices for product ids, depending on realtime prices and scale
 */
export const runtimePrices = <ThrowOnError extends boolean = false>(
  options: Options<RuntimePricesData, ThrowOnError>
): RequestResult<RuntimePricesResponses, RuntimePricesErrors, ThrowOnError> =>
  (options.client ?? client).post<RuntimePricesResponses, RuntimePricesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/runtime/products',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Load runtime prices for a given product id and scale, depending on realtime prices and scales
 */
export const runtimePrice = <ThrowOnError extends boolean = false>(
  options: Options<RuntimePriceData, ThrowOnError>
): RequestResult<RuntimePriceResponses, RuntimePriceErrors, ThrowOnError> =>
  (options.client ?? client).post<RuntimePriceResponses, RuntimePriceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/runtime/product',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Self registration
 *
 * Returns email of new user.
 */
export const selfRegister = <ThrowOnError extends boolean = false>(
  options: Options<SelfRegisterData, ThrowOnError>
): RequestResult<SelfRegisterResponses, SelfRegisterErrors, ThrowOnError> =>
  (options.client ?? client).post<SelfRegisterResponses, SelfRegisterErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/registration',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Validate email addresses
 *
 * Checks if emails are already in use, invited or invalid
 */
export const validateEmails = <ThrowOnError extends boolean = false>(
  options: Options<ValidateEmailsData, ThrowOnError>
): RequestResult<ValidateEmailsResponses, ValidateEmailsErrors, ThrowOnError> =>
  (options.client ?? client).post<ValidateEmailsResponses, ValidateEmailsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/registration/validate-mail',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Self invitation
 *
 * Sends an invitation email to the given user email address
 */
export const inviteYourself = <ThrowOnError extends boolean = false>(
  options: Options<InviteYourselfData, ThrowOnError>
): RequestResult<InviteYourselfResponses, InviteYourselfErrors, ThrowOnError> =>
  (options.client ?? client).post<InviteYourselfResponses, InviteYourselfErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/registration/self-invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Registration following invitation.
 *
 * Add new user whose email is encoded by the provided token. This token originates from the link to the registration page sent to users by invitation mails. Before allowing a user to access the registration page, the token can be validated by the Validate register-token action. Returns used token.
 */
export const registerInvitedUser = <ThrowOnError extends boolean = false>(
  options: Options<RegisterInvitedUserData, ThrowOnError>
): RequestResult<RegisterInvitedUserResponses, RegisterInvitedUserErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RegisterInvitedUserResponses,
    RegisterInvitedUserErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/registration/invitation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Validate register-user token.
 *
 * If the response to this action is 200 OK the token is valid. This action can be used to validate a register-user token before allowing an invited user to access the registration page. This token originates in the link to the registration page sent to user's via invitation mails. Returns validated token.
 */
export const validateRegisterToken = <ThrowOnError extends boolean = false>(
  options: Options<ValidateRegisterTokenData, ThrowOnError>
): RequestResult<ValidateRegisterTokenResponses, ValidateRegisterTokenErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ValidateRegisterTokenResponses,
    ValidateRegisterTokenErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/registration/invitation/validate-token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Reject quote by id
 *
 * Return id of hte rejected quote.
 */
export const rejectQuote = <ThrowOnError extends boolean = false>(
  options: Options<RejectQuoteData, ThrowOnError>
): RequestResult<unknown, RejectQuoteErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, RejectQuoteErrors, ThrowOnError>({
    url: '/storefront/quotes/{id}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Load activity for quote by id
 */
export const getActivity = <ThrowOnError extends boolean = false>(
  options: Options<GetActivityData, ThrowOnError>
): RequestResult<unknown, GetActivityErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, GetActivityErrors, ThrowOnError>({
    url: '/storefront/quotes/{id}/activity',
    ...options
  })

/**
 * Post activity for quote by id
 */
export const postActivity = <ThrowOnError extends boolean = false>(
  options: Options<PostActivityData, ThrowOnError>
): RequestResult<unknown, PostActivityErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, PostActivityErrors, ThrowOnError>({
    url: '/storefront/quotes/{id}/activity',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Dearchive quote
 *
 * Returns id of dearchived quote
 */
export const dearchiveQuote = <ThrowOnError extends boolean = false>(
  options: Options<DearchiveQuoteData, ThrowOnError>
): RequestResult<DearchiveQuoteResponses, DearchiveQuoteErrors, ThrowOnError> =>
  (options.client ?? client).post<DearchiveQuoteResponses, DearchiveQuoteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/quotes/actions/dearchive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Archive quote
 *
 * Returns id of archived quote
 */
export const archiveQuote = <ThrowOnError extends boolean = false>(
  options: Options<ArchiveQuoteData, ThrowOnError>
): RequestResult<ArchiveQuoteResponses, ArchiveQuoteErrors, ThrowOnError> =>
  (options.client ?? client).post<ArchiveQuoteResponses, ArchiveQuoteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/quotes/actions/archive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Create new quote request
 *
 * Returns id of created quote
 */
export const createQuoteRequest = <ThrowOnError extends boolean = false>(
  options: Options<CreateQuoteRequestData, ThrowOnError>
): RequestResult<CreateQuoteRequestResponses, CreateQuoteRequestErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateQuoteRequestResponses,
    CreateQuoteRequestErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/quote-requests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Delete quote request. Returns id of the deleted quote request.
 */
export const deleteQuoteRequest = <ThrowOnError extends boolean = false>(
  options: Options<DeleteQuoteRequestData, ThrowOnError>
): RequestResult<DeleteQuoteRequestResponses, DeleteQuoteRequestErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteQuoteRequestResponses,
    DeleteQuoteRequestErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/quote-requests/{id}',
    ...options
  })

/**
 * Get quote request
 */
export const getQuoteRequest = <ThrowOnError extends boolean = false>(
  options: Options<GetQuoteRequestData, ThrowOnError>
): RequestResult<GetQuoteRequestResponses, GetQuoteRequestErrors, ThrowOnError> =>
  (options.client ?? client).get<GetQuoteRequestResponses, GetQuoteRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/quote-requests/{id}',
    ...options
  })

/**
 * Update quote request. Returns id of the updated quote request
 */
export const updateQuoteRequest = <ThrowOnError extends boolean = false>(
  options: Options<UpdateQuoteRequestData, ThrowOnError>
): RequestResult<UpdateQuoteRequestResponses, UpdateQuoteRequestErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UpdateQuoteRequestResponses,
    UpdateQuoteRequestErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/quote-requests/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Add item to quote request. Returns id of the quote request.
 */
export const addQuoteLineItem = <ThrowOnError extends boolean = false>(
  options: Options<AddQuoteLineItemData, ThrowOnError>
): RequestResult<AddQuoteLineItemResponses, AddQuoteLineItemErrors, ThrowOnError> =>
  (options.client ?? client).post<AddQuoteLineItemResponses, AddQuoteLineItemErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/quote-requests/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Send quote request to portal owner. Returns id of the quote request.
 */
export const sendQuoteRequest = <ThrowOnError extends boolean = false>(
  options: Options<SendQuoteRequestData, ThrowOnError>
): RequestResult<SendQuoteRequestResponses, SendQuoteRequestErrors, ThrowOnError> =>
  (options.client ?? client).post<SendQuoteRequestResponses, SendQuoteRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/quote-requests/{id}/send',
    ...options
  })

/**
 * Add order to cart
 *
 *  Returns successfulness of the operation.
 */
export const addOrderToCart = <ThrowOnError extends boolean = false>(
  options: Options<AddOrderToCartData, ThrowOnError>
): RequestResult<AddOrderToCartResponses, AddOrderToCartErrors, ThrowOnError> =>
  (options.client ?? client).post<AddOrderToCartResponses, AddOrderToCartErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/orders/{orderId}/to-cart',
    ...options
  })

/**
 * Sends order
 *
 * Sends a prepared order. Order permission is necessary with no limit exceedance. Returns id of sent order.
 */
export const approveOrder = <ThrowOnError extends boolean = false>(
  options: Options<ApproveOrderData, ThrowOnError>
): RequestResult<unknown, ApproveOrderErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, ApproveOrderErrors, ThrowOnError>({
    url: '/storefront/orders/{id}/send',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get RMA process information for order
 */
export const getOrderRma = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderRmaData, ThrowOnError>
): RequestResult<unknown, GetOrderRmaErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, GetOrderRmaErrors, ThrowOnError>({
    url: '/storefront/orders/{id}/rma',
    ...options
  })

/**
 * Request RMA process for some order positions
 */
export const createOrderRma = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrderRmaData, ThrowOnError>
): RequestResult<unknown, CreateOrderRmaErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, CreateOrderRmaErrors, ThrowOnError>({
    url: '/storefront/orders/{id}/rma',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Request approval for an existing order
 *
 * Order permission must be non-existent or order limit exceedance is necessary. Returns id of requested order.
 */
export const requestOrderById = <ThrowOnError extends boolean = false>(
  options: Options<RequestOrderByIdData, ThrowOnError>
): RequestResult<unknown, RequestOrderByIdErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, RequestOrderByIdErrors, ThrowOnError>({
    url: '/storefront/orders/{id}/request',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Rejects order
 *
 * Rejects a prepared order. Returns id of rejected order.
 */
export const rejectOrder = <ThrowOnError extends boolean = false>(
  options: Options<RejectOrderData, ThrowOnError>
): RequestResult<unknown, RejectOrderErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, RejectOrderErrors, ThrowOnError>({
    url: '/storefront/orders/{id}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Validate order number
 *
 * Check validity of self-created order number
 */
export const validateOrderNumber = <ThrowOnError extends boolean = false>(
  options: Options<ValidateOrderNumberData, ThrowOnError>
): RequestResult<ValidateOrderNumberResponses, ValidateOrderNumberErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ValidateOrderNumberResponses,
    ValidateOrderNumberErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Create order
 *
 * Create an order from quote. Order permission is necessary.
 */
export const sendQuote = <ThrowOnError extends boolean = false>(
  options: Options<SendQuoteData, ThrowOnError>
): RequestResult<unknown, SendQuoteErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, SendQuoteErrors, ThrowOnError>({
    url: '/storefront/order/actions/send-quote',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Create order
 *
 * Create an order from supplier cart. Order permission is necessary.
 */
export const sendCart = <ThrowOnError extends boolean = false>(
  options: Options<SendCartData, ThrowOnError>
): RequestResult<unknown, SendCartErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, SendCartErrors, ThrowOnError>({
    url: '/storefront/order/actions/send-cart',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const sendCartTopi = <ThrowOnError extends boolean = false>(
  options: Options<SendCartTopiData, ThrowOnError>
): RequestResult<SendCartTopiResponses, SendCartTopiErrors, ThrowOnError> =>
  (options.client ?? client).post<SendCartTopiResponses, SendCartTopiErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/order/actions/send-cart-topi',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Create an order from quote waiting for approval
 *
 * Order permission must be non-existent or order limit exceedance is necessary.
 */
export const requestQuote = <ThrowOnError extends boolean = false>(
  options: Options<RequestQuoteData, ThrowOnError>
): RequestResult<unknown, RequestQuoteErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, RequestQuoteErrors, ThrowOnError>({
    url: '/storefront/order/actions/request-quote',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Create an order from cart waiting for approval.
 *
 * Order permission must be non-existent or order limit exceedance is necessary.
 */
export const requestCart = <ThrowOnError extends boolean = false>(
  options: Options<RequestCartData, ThrowOnError>
): RequestResult<unknown, RequestCartErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, RequestCartErrors, ThrowOnError>({
    url: '/storefront/order/actions/request-cart',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Validate email address
 *
 * Checks if email address is already in use, invited or invalid
 */
export const validateEmails1 = <ThrowOnError extends boolean = false>(
  options: Options<ValidateEmails1Data, ThrowOnError>
): RequestResult<ValidateEmails1Responses, ValidateEmails1Errors, ThrowOnError> =>
  (options.client ?? client).post<ValidateEmails1Responses, ValidateEmails1Errors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/emails/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get preview email for a collection
 */
export const getSendCollectionMail = <ThrowOnError extends boolean = false>(
  options: Options<GetSendCollectionMailData, ThrowOnError>
): RequestResult<GetSendCollectionMailResponses, GetSendCollectionMailErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetSendCollectionMailResponses,
    GetSendCollectionMailErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/emails/send-collection/{id}',
    ...options
  })

/**
 * Send email for a collection
 *
 * Returns serial of sent collection.
 */
export const sendCollectionMail = <ThrowOnError extends boolean = false>(
  options: Options<SendCollectionMailData, ThrowOnError>
): RequestResult<SendCollectionMailResponses, SendCollectionMailErrors, ThrowOnError> =>
  (options.client ?? client).post<
    SendCollectionMailResponses,
    SendCollectionMailErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/emails/send-collection/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get request email for a product with no price
 */
export const getProductRequestMail = <ThrowOnError extends boolean = false>(
  options: Options<GetProductRequestMailData, ThrowOnError>
): RequestResult<GetProductRequestMailResponses, GetProductRequestMailErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetProductRequestMailResponses,
    GetProductRequestMailErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/emails/request-product/{id}',
    ...options
  })

/**
 * Send request email for a product with no price
 *
 * Returns the serial of the requested product.
 */
export const sendProductRequestMail = <ThrowOnError extends boolean = false>(
  options: Options<SendProductRequestMailData, ThrowOnError>
): RequestResult<SendProductRequestMailResponses, SendProductRequestMailErrors, ThrowOnError> =>
  (options.client ?? client).post<
    SendProductRequestMailResponses,
    SendProductRequestMailErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/emails/request-product/{id}',
    ...options
  })

/**
 * Invite new colleagues
 *
 * Send invitation emails to all email addresses in payload.
 */
export const inviteColleagues = <ThrowOnError extends boolean = false>(
  options: Options<InviteColleaguesData, ThrowOnError>
): RequestResult<InviteColleaguesResponses, InviteColleaguesErrors, ThrowOnError> =>
  (options.client ?? client).post<InviteColleaguesResponses, InviteColleaguesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/emails/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Load product
 *
 * Returns the product with the given product classes.
 */
export const getProductInformation = <ThrowOnError extends boolean = false>(
  options: Options<GetProductInformationData, ThrowOnError>
): RequestResult<GetProductInformationResponses, GetProductInformationErrors, ThrowOnError> =>
  (options.client ?? client).post<
    GetProductInformationResponses,
    GetProductInformationErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/cto/productinformation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get collections.
 *
 * Returns list of filtered and sorted collections
 */
export const getCollections = <ThrowOnError extends boolean = false>(
  options?: Options<GetCollectionsData, ThrowOnError>
): RequestResult<GetCollectionsResponses, GetCollectionsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetCollectionsResponses, GetCollectionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/collections',
    ...options
  })

/**
 * Create new collection
 *
 * Returns the serial of the created collection
 */
export const createCollection = <ThrowOnError extends boolean = false>(
  options: Options<CreateCollectionData, ThrowOnError>
): RequestResult<CreateCollectionResponses, CreateCollectionErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateCollectionResponses, CreateCollectionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/collections',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Delete collection
 */
export const deleteCollection = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCollectionData, ThrowOnError>
): RequestResult<DeleteCollectionResponses, DeleteCollectionErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteCollectionResponses,
    DeleteCollectionErrors,
    ThrowOnError
  >({ url: '/storefront/collections/{collectionId}', ...options })

/**
 * Get collection
 */
export const getCollection = <ThrowOnError extends boolean = false>(
  options: Options<GetCollectionData, ThrowOnError>
): RequestResult<GetCollectionResponses, GetCollectionErrors, ThrowOnError> =>
  (options.client ?? client).get<GetCollectionResponses, GetCollectionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/collections/{collectionId}',
    ...options
  })

/**
 * Update collection
 *
 * Returns the serial of the updated collection
 */
export const updateCollection = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCollectionData, ThrowOnError>
): RequestResult<unknown, UpdateCollectionErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateCollectionErrors, ThrowOnError>({
    url: '/storefront/collections/{collectionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Add item to collection
 */
export const addToCollection = <ThrowOnError extends boolean = false>(
  options: Options<AddToCollectionData, ThrowOnError>
): RequestResult<AddToCollectionResponses, AddToCollectionErrors, ThrowOnError> =>
  (options.client ?? client).post<AddToCollectionResponses, AddToCollectionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/collections/{collectionId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Add collection to cart
 *
 * Returns successfulness of the operation
 */
export const addCollectionToCart = <ThrowOnError extends boolean = false>(
  options: Options<AddCollectionToCartData, ThrowOnError>
): RequestResult<AddCollectionToCartResponses, AddCollectionToCartErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AddCollectionToCartResponses,
    AddCollectionToCartErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/collections/actions/to-cart',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Create quote request from collection
 *
 * Returns the serial of the created quote
 */
export const requestQuote2 = <ThrowOnError extends boolean = false>(
  options: Options<RequestQuote2Data, ThrowOnError>
): RequestResult<RequestQuote2Responses, RequestQuote2Errors, ThrowOnError> =>
  (options.client ?? client).post<RequestQuote2Responses, RequestQuote2Errors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/collections/actions/request-quote',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Duplicate collection
 *
 * Returns the serial of the new collection
 */
export const duplicateCollection = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateCollectionData, ThrowOnError>
): RequestResult<DuplicateCollectionResponses, DuplicateCollectionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    DuplicateCollectionResponses,
    DuplicateCollectionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/collections/actions/duplicate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Dearchive collection
 *
 * Returns the serial of the dearchived collection
 */
export const dearchiveCollection = <ThrowOnError extends boolean = false>(
  options: Options<DearchiveCollectionData, ThrowOnError>
): RequestResult<DearchiveCollectionResponses, DearchiveCollectionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    DearchiveCollectionResponses,
    DearchiveCollectionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/collections/actions/dearchive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Archive collection
 *
 * Returns the serial of the archived collection
 */
export const archiveCollection = <ThrowOnError extends boolean = false>(
  options: Options<ArchiveCollectionData, ThrowOnError>
): RequestResult<ArchiveCollectionResponses, ArchiveCollectionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ArchiveCollectionResponses,
    ArchiveCollectionErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/collections/actions/archive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Optimize cart with given optimization type
 *
 * Returns "Optimization completed" upon completion.
 */
export const optimizeCart = <ThrowOnError extends boolean = false>(
  options: Options<OptimizeCartData, ThrowOnError>
): RequestResult<OptimizeCartResponses, OptimizeCartErrors, ThrowOnError> =>
  (options.client ?? client).post<OptimizeCartResponses, OptimizeCartErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/optimizations/apply',
    ...options
  })

/**
 * Create cart item
 *
 * Returns id of new cart item.
 */
export const createLineItem = <ThrowOnError extends boolean = false>(
  options: Options<CreateLineItemData, ThrowOnError>
): RequestResult<CreateLineItemResponses, CreateLineItemErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateLineItemResponses, CreateLineItemErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Move cart item
 *
 * Returns id of target cart
 */
export const moveLineItem = <ThrowOnError extends boolean = false>(
  options: Options<MoveLineItemData, ThrowOnError>
): RequestResult<unknown, MoveLineItemErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, MoveLineItemErrors, ThrowOnError>({
    url: '/storefront/carts/items/{id}/move',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Create quote request from cart
 *
 * Returns the id of the new quote.
 */
export const requestQuote1 = <ThrowOnError extends boolean = false>(
  options?: Options<RequestQuote1Data, ThrowOnError>
): RequestResult<RequestQuote1Responses, RequestQuote1Errors, ThrowOnError> =>
  (options?.client ?? client).post<RequestQuote1Responses, RequestQuote1Errors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/actions/request-quote',
    ...options
  })

/**
 * Empty the cart
 *
 * Removes all products from the cart. Returns the id of the cart.
 */
export const emptyCart = <ThrowOnError extends boolean = false>(
  options?: Options<EmptyCartData, ThrowOnError>
): RequestResult<EmptyCartResponses, EmptyCartErrors, ThrowOnError> =>
  (options?.client ?? client).post<EmptyCartResponses, EmptyCartErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/actions/empty',
    ...options
  })

/**
 * Get all addresses
 */
export const readAddresses = <ThrowOnError extends boolean = false>(
  options?: Options<ReadAddressesData, ThrowOnError>
): RequestResult<ReadAddressesResponses, ReadAddressesErrors, ThrowOnError> =>
  (options?.client ?? client).get<ReadAddressesResponses, ReadAddressesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/addresses',
    ...options
  })

/**
 * Create new address
 */
export const createAddress = <ThrowOnError extends boolean = false>(
  options: Options<CreateAddressData, ThrowOnError>
): RequestResult<unknown, CreateAddressErrors, ThrowOnError> =>
  (options.client ?? client).post<unknown, CreateAddressErrors, ThrowOnError>({
    url: '/storefront/addresses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Validate address for checkout
 */
export const validateAddressCheckout = <ThrowOnError extends boolean = false>(
  options: Options<ValidateAddressCheckoutData, ThrowOnError>
): RequestResult<ValidateAddressCheckoutResponses, ValidateAddressCheckoutErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ValidateAddressCheckoutResponses,
    ValidateAddressCheckoutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/addresses/validate/{type}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Update user
 *
 * Update the user identified by the id provided as path variable
 */
export const updateUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserData, ThrowOnError>
): RequestResult<unknown, UpdateUserErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateUserErrors, ThrowOnError>({
    url: '/storefront/user/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Update user's settings
 *
 * Update settings of the user identified by id provided as path variable. Returns the id of the user.
 */
export const updateUserSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserSettingsData, ThrowOnError>
): RequestResult<UpdateUserSettingsResponses, UpdateUserSettingsErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UpdateUserSettingsResponses,
    UpdateUserSettingsErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/user/{id}/setting',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Update user's permissions
 *
 * Update permissions of the user identified by id provided as path variable. Returns the id of user.
 */
export const updateUserPermissions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserPermissionsData, ThrowOnError>
): RequestResult<unknown, UpdateUserPermissionsErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateUserPermissionsErrors, ThrowOnError>({
    url: '/storefront/user/{id}/permission',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Update user's credentials
 *
 * Update credentials of the user
 */
export const updateUserCredentials = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserCredentialsData, ThrowOnError>
): RequestResult<unknown, UpdateUserCredentialsErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateUserCredentialsErrors, ThrowOnError>({
    url: '/storefront/user/me/credentials',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Load quote by id
 */
export const loadQuoteById = <ThrowOnError extends boolean = false>(
  options: Options<LoadQuoteByIdData, ThrowOnError>
): RequestResult<unknown, LoadQuoteByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, LoadQuoteByIdErrors, ThrowOnError>({
    url: '/storefront/quotes/{id}',
    ...options
  })

/**
 * Update quote
 */
export const updateQuote = <ThrowOnError extends boolean = false>(
  options: Options<UpdateQuoteData, ThrowOnError>
): RequestResult<unknown, UpdateQuoteErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateQuoteErrors, ThrowOnError>({
    url: '/storefront/quotes/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Update quote item
 *
 * Returns new timestamp of updated quote
 */
export const updateQuoteItem = <ThrowOnError extends boolean = false>(
  options: Options<UpdateQuoteItemData, ThrowOnError>
): RequestResult<unknown, UpdateQuoteItemErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateQuoteItemErrors, ThrowOnError>({
    url: '/storefront/quotes/{id}/items/{itemId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Delete item of quote request
 *
 * Returns id of the deleted quote
 */
export const deleteLineItem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLineItemData, ThrowOnError>
): RequestResult<unknown, DeleteLineItemErrors, ThrowOnError> =>
  (options.client ?? client).delete<unknown, DeleteLineItemErrors, ThrowOnError>({
    url: '/storefront/quote-requests/{id}/items/{itemId}',
    ...options
  })

/**
 * Update item of quote request
 *
 * Returns id of the updated item.
 */
export const updateLineItem = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLineItemData, ThrowOnError>
): RequestResult<unknown, UpdateLineItemErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateLineItemErrors, ThrowOnError>({
    url: '/storefront/quote-requests/{id}/items/{itemId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Delete order item
 *
 * Delete the order item identified by the ids provided as path variables.Deletes the whole order if the item to be deleted is the last item in the order.  Returns id of order.
 */
export const deleteOrderItem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOrderItemData, ThrowOnError>
): RequestResult<unknown, DeleteOrderItemErrors, ThrowOnError> =>
  (options.client ?? client).delete<unknown, DeleteOrderItemErrors, ThrowOnError>({
    url: '/storefront/orders/{orderId}/items/{itemId}',
    ...options
  })

/**
 * Update order item
 *
 * Update the order item identified by the ids provided as path variables. Returns new timestamp for order.
 */
export const patchOrderItem = <ThrowOnError extends boolean = false>(
  options: Options<PatchOrderItemData, ThrowOnError>
): RequestResult<unknown, PatchOrderItemErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, PatchOrderItemErrors, ThrowOnError>({
    url: '/storefront/orders/{orderId}/items/{itemId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Update order
 *
 * Update the order identified by the id provided as path variable. Returns id of updated order.
 */
export const updateOrder = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrderData, ThrowOnError>
): RequestResult<unknown, UpdateOrderErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateOrderErrors, ThrowOnError>({
    url: '/storefront/orders/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Update OrderLimitUser
 *
 * Update the OrderLimitUser identified by the id provided as path variable.Returns the id of the updated user if successful.
 */
export const updateOrderLimitUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrderLimitUserData, ThrowOnError>
): RequestResult<UpdateOrderLimitUserResponses, UpdateOrderLimitUserErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UpdateOrderLimitUserResponses,
    UpdateOrderLimitUserErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/limits/users/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get the company order limit
 */
export const readCompanyOrderLimit = <ThrowOnError extends boolean = false>(
  options?: Options<ReadCompanyOrderLimitData, ThrowOnError>
): RequestResult<ReadCompanyOrderLimitResponses, ReadCompanyOrderLimitErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ReadCompanyOrderLimitResponses,
    ReadCompanyOrderLimitErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/limits/company',
    ...options
  })

/**
 * Update DefaultOrderLimit
 *
 * Update the DefaultOrderLimit for your company. Returns "DefaultOrderLimit was updated!" if successful
 */
export const updateCompanyOrderLimit = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCompanyOrderLimitData, ThrowOnError>
): RequestResult<UpdateCompanyOrderLimitResponses, UpdateCompanyOrderLimitErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    UpdateCompanyOrderLimitResponses,
    UpdateCompanyOrderLimitErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/limits/company',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Delete collection item
 *
 * Returns the serial of the deleted item and its collection
 */
export const deleteLineItem1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLineItem1Data, ThrowOnError>
): RequestResult<unknown, DeleteLineItem1Errors, ThrowOnError> =>
  (options.client ?? client).delete<unknown, DeleteLineItem1Errors, ThrowOnError>({
    url: '/storefront/collections/{collectionId}/items/{itemId}',
    ...options
  })

/**
 * Update collection item
 *
 * Returns the serial of the updated item
 */
export const updateLineItem1 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLineItem1Data, ThrowOnError>
): RequestResult<unknown, UpdateLineItem1Errors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateLineItem1Errors, ThrowOnError>({
    url: '/storefront/collections/{collectionId}/items/{itemId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Delete cart item
 *
 * Returns id of deleted cart item
 */
export const deleteLineItem2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLineItem2Data, ThrowOnError>
): RequestResult<unknown, DeleteLineItem2Errors, ThrowOnError> =>
  (options.client ?? client).delete<unknown, DeleteLineItem2Errors, ThrowOnError>({
    url: '/storefront/carts/items/{id}',
    ...options
  })

/**
 * Update cart item
 *
 * Returns new timestamp for updated cart
 */
export const updateLineItem2 = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLineItem2Data, ThrowOnError>
): RequestResult<UpdateLineItem2Responses, UpdateLineItem2Errors, ThrowOnError> =>
  (options.client ?? client).patch<UpdateLineItem2Responses, UpdateLineItem2Errors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/items/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Delete address
 *
 * Delete the address identified by the id provided as path variable.
 */
export const deleteAddress = <ThrowOnError extends boolean = false>(
  options: Options<DeleteAddressData, ThrowOnError>
): RequestResult<unknown, DeleteAddressErrors, ThrowOnError> =>
  (options.client ?? client).delete<unknown, DeleteAddressErrors, ThrowOnError>({
    url: '/storefront/addresses/{id}',
    ...options
  })

/**
 * Update address
 *
 * Update the address identified by the id provided as path variable
 */
export const updateAddress = <ThrowOnError extends boolean = false>(
  options: Options<UpdateAddressData, ThrowOnError>
): RequestResult<unknown, UpdateAddressErrors, ThrowOnError> =>
  (options.client ?? client).patch<unknown, UpdateAddressErrors, ThrowOnError>({
    url: '/storefront/addresses/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Get all employees
 */
export const readEmployees = <ThrowOnError extends boolean = false>(
  options?: Options<ReadEmployeesData, ThrowOnError>
): RequestResult<unknown, ReadEmployeesErrors, ThrowOnError> =>
  (options?.client ?? client).get<unknown, ReadEmployeesErrors, ThrowOnError>({
    url: '/storefront/user',
    ...options
  })

/**
 * Delete user
 *
 * Returns the id of the deleted user
 */
export const deleteUser = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUserData, ThrowOnError>
): RequestResult<unknown, DeleteUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<unknown, DeleteUserErrors, ThrowOnError>({
    url: '/storefront/user/{userId}',
    ...options
  })

/**
 * Get user
 */
export const getEmployeeById = <ThrowOnError extends boolean = false>(
  options: Options<GetEmployeeByIdData, ThrowOnError>
): RequestResult<unknown, GetEmployeeByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, GetEmployeeByIdErrors, ThrowOnError>({
    url: '/storefront/user/{userId}',
    ...options
  })

/**
 * Get my user
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentUserData, ThrowOnError>
): RequestResult<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/user/me',
    ...options
  })

/**
 * Get refresh token for basic auth
 *
 * Endpoint to obtain refresh token for the storefront API based on basic auth credentials. Returns new refresh token.
 */
export const login = <ThrowOnError extends boolean = false>(
  options?: Options<LoginData, ThrowOnError>
): RequestResult<LoginResponses, LoginErrors, ThrowOnError> =>
  (options?.client ?? client).get<LoginResponses, LoginErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/user/actions/login',
    ...options
  })

/**
 * Get access token
 *
 * Endpoint to obtain access token for the storefront API based on refresh token
 */
export const accessToken = <ThrowOnError extends boolean = false>(
  options: Options<AccessTokenData, ThrowOnError>
): RequestResult<AccessTokenResponses, AccessTokenErrors, ThrowOnError> =>
  (options.client ?? client).get<AccessTokenResponses, AccessTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/user/actions/access-token',
    ...options
  })

/**
 * Get the companies' relations
 */
export const subsidiaries = <ThrowOnError extends boolean = false>(
  options?: Options<SubsidiariesData, ThrowOnError>
): RequestResult<SubsidiariesResponses, SubsidiariesErrors, ThrowOnError> =>
  (options?.client ?? client).get<SubsidiariesResponses, SubsidiariesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/subsidiaries',
    ...options
  })

/**
 * Get access token for subsidiary
 *
 * Endpoint to obtain session tokens for the storefront API based on subsidiary
 */
export const switchToSubsidiary = <ThrowOnError extends boolean = false>(
  options: Options<SwitchToSubsidiaryData, ThrowOnError>
): RequestResult<SwitchToSubsidiaryResponses, SwitchToSubsidiaryErrors, ThrowOnError> =>
  (options.client ?? client).get<
    SwitchToSubsidiaryResponses,
    SwitchToSubsidiaryErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/subsidiaries/{subsidiaryId}/token',
    ...options
  })

/**
 * Search companies' relations
 */
export const searchForSubsidiaries = <ThrowOnError extends boolean = false>(
  options?: Options<SearchForSubsidiariesData, ThrowOnError>
): RequestResult<SearchForSubsidiariesResponses, SearchForSubsidiariesErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    SearchForSubsidiariesResponses,
    SearchForSubsidiariesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/subsidiaries/search',
    ...options
  })

/**
 * Check if you are in a subsidiary
 *
 * Returns the portal company and the relation of the user to it. Enum values: NONE = Is not impersonated. BRANCH: Is admin of main customer company impersonating a member of an branch company. OWNER: Is shop owner impersonating a customer.
 */
export const impersonationStatus = <ThrowOnError extends boolean = false>(
  options?: Options<ImpersonationStatusData, ThrowOnError>
): RequestResult<ImpersonationStatusResponses, ImpersonationStatusErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ImpersonationStatusResponses,
    ImpersonationStatusErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/subsidiaries/impersonation-status',
    ...options
  })

/**
 * Get the dashboard
 *
 * Get the store's start page. This operation is pageable but does not support sorting.
 */
export const featured = <ThrowOnError extends boolean = false>(
  options?: Options<FeaturedData, ThrowOnError>
): RequestResult<FeaturedResponses, FeaturedErrors, ThrowOnError> =>
  (options?.client ?? client).get<FeaturedResponses, FeaturedErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/startpages',
    ...options
  })

/**
 * [Deprecation: Since 29 September 2026 00:00:00 UTC] Search for products with the provided keyword. At least one filter or keyword is required. Keyword must be at least 2 chars. Use lastKey of previous slice to get next slice.
 *
 * Params are ?keyword=apple%20ipad&filters=MAN88&lastKey=123456&size=30&sort=... Parameter lastKey can be omitted or 0 if first slice is requested.
 */
export const searchProductSlice = <ThrowOnError extends boolean = false>(
  options?: Options<SearchProductSliceData, ThrowOnError>
): RequestResult<SearchProductSliceResponses, SearchProductSliceErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    SearchProductSliceResponses,
    SearchProductSliceErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/search-products',
    ...options
  })

/**
 * Get Custom Terms
 */
export const getCustomTerms = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomTermsData, ThrowOnError>
): RequestResult<GetCustomTermsResponses, GetCustomTermsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetCustomTermsResponses, GetCustomTermsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/registration/customterms',
    ...options
  })

/**
 * Load quotes for portal
 */
export const loadQuotes = <ThrowOnError extends boolean = false>(
  options?: Options<LoadQuotesData, ThrowOnError>
): RequestResult<LoadQuotesResponses, LoadQuotesErrors, ThrowOnError> =>
  (options?.client ?? client).get<LoadQuotesResponses, LoadQuotesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/quotes',
    ...options
  })

/**
 * Print quote by id
 */
export const printQuote = <ThrowOnError extends boolean = false>(
  options: Options<PrintQuoteData, ThrowOnError>
): RequestResult<unknown, PrintQuoteErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, PrintQuoteErrors, ThrowOnError>({
    url: '/storefront/quotes/{id}/print',
    ...options
  })

/**
 * Get datasheet for a quote item
 */
export const getDataHtmlDatasheet = <ThrowOnError extends boolean = false>(
  options: Options<GetDataHtmlDatasheetData, ThrowOnError>
): RequestResult<unknown, GetDataHtmlDatasheetErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, GetDataHtmlDatasheetErrors, ThrowOnError>({
    url: '/storefront/quotes/{id}/items/{itemId}/datasheet',
    ...options
  })

/**
 * Load activity for quote by id
 */
export const getActivitySse = <ThrowOnError extends boolean = false>(
  options: Options<GetActivitySseData, ThrowOnError, unknown>
): Promise<ServerSentEventsResult<unknown>> =>
  (options.client ?? client).sse.get<unknown, GetActivitySseErrors, ThrowOnError>({
    url: '/storefront/quotes/{id}/activity-sse',
    ...options
  })

/**
 * Count new quotes for portal
 */
export const countNewQuotes = <ThrowOnError extends boolean = false>(
  options?: Options<CountNewQuotesData, ThrowOnError>
): RequestResult<CountNewQuotesResponses, CountNewQuotesErrors, ThrowOnError> =>
  (options?.client ?? client).get<CountNewQuotesResponses, CountNewQuotesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/quotes/new-count',
    ...options
  })

/**
 * Load quote filters for portal
 */
export const getFilters = <ThrowOnError extends boolean = false>(
  options?: Options<GetFiltersData, ThrowOnError>
): RequestResult<unknown, GetFiltersErrors, ThrowOnError> =>
  (options?.client ?? client).get<unknown, GetFiltersErrors, ThrowOnError>({
    url: '/storefront/quotes/filters',
    ...options
  })

/**
 * Load quote by id
 */
export const loadQuoteByIdSse = <ThrowOnError extends boolean = false>(
  options: Options<LoadQuoteByIdSseData, ThrowOnError, unknown>
): Promise<ServerSentEventsResult<unknown>> =>
  (options.client ?? client).sse.get<unknown, LoadQuoteByIdSseErrors, ThrowOnError>({
    url: '/storefront/quotes-sse/{id}',
    ...options
  })

/**
 * Is the product in any quote request
 */
export const getIsProductInQuoteRequest = <ThrowOnError extends boolean = false>(
  options: Options<GetIsProductInQuoteRequestData, ThrowOnError>
): RequestResult<
  GetIsProductInQuoteRequestResponses,
  GetIsProductInQuoteRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetIsProductInQuoteRequestResponses,
    GetIsProductInQuoteRequestErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/quote-requests/{id}/hasProduct',
    ...options
  })

/**
 * Get quote request for product id.
 */
export const getQuoteRequestForProduct = <ThrowOnError extends boolean = false>(
  options: Options<GetQuoteRequestForProductData, ThrowOnError>
): RequestResult<
  GetQuoteRequestForProductResponses,
  GetQuoteRequestForProductErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetQuoteRequestForProductResponses,
    GetQuoteRequestForProductErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/quote-requests/products/{id}',
    ...options
  })

/**
 * Search for products with the provided keyword. At least one filter or keyword is required. Keyword must be at least 2 chars.
 *
 * params are ?keyword=apple%20ipad&filters=MAN88&page=0&size=30&sort=...
 */
export const searchProduct = <ThrowOnError extends boolean = false>(
  options?: Options<SearchProductData, ThrowOnError>
): RequestResult<SearchProductResponses, SearchProductErrors, ThrowOnError> =>
  (options?.client ?? client).get<SearchProductResponses, SearchProductErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/products',
    ...options
  })

/**
 * Load a product identified by its id
 */
export const loadFullProduct = <ThrowOnError extends boolean = false>(
  options: Options<LoadFullProductData, ThrowOnError>
): RequestResult<LoadFullProductResponses, LoadFullProductErrors, ThrowOnError> =>
  (options.client ?? client).get<LoadFullProductResponses, LoadFullProductErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/products/{id}',
    ...options
  })

/**
 * Datasheet for a product
 */
export const getDataHtmlDatasheet1 = <ThrowOnError extends boolean = false>(
  options: Options<GetDataHtmlDatasheet1Data, ThrowOnError>
): RequestResult<unknown, GetDataHtmlDatasheet1Errors, ThrowOnError> =>
  (options.client ?? client).get<unknown, GetDataHtmlDatasheet1Errors, ThrowOnError>({
    url: '/storefront/products/{id}/datasheet/{type}',
    ...options
  })

/**
 * Dynamic filters for product search with the provided search keyword and filters.
 */
export const filterNodes = <ThrowOnError extends boolean = false>(
  options?: Options<FilterNodesData, ThrowOnError>
): RequestResult<FilterNodesResponses, FilterNodesErrors, ThrowOnError> =>
  (options?.client ?? client).get<FilterNodesResponses, FilterNodesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/products/filters',
    ...options
  })

/**
 * Load bundle items for a given product
 */
export const loadBundleItemsForProduct = <ThrowOnError extends boolean = false>(
  options: Options<LoadBundleItemsForProductData, ThrowOnError>
): RequestResult<unknown, LoadBundleItemsForProductErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, LoadBundleItemsForProductErrors, ThrowOnError>({
    url: '/storefront/products/bundle-items/{id}',
    ...options
  })

/**
 * Load accessories for a given product
 */
export const loadAccessoriesForProduct = <ThrowOnError extends boolean = false>(
  options: Options<LoadAccessoriesForProductData, ThrowOnError>
): RequestResult<unknown, LoadAccessoriesForProductErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, LoadAccessoriesForProductErrors, ThrowOnError>({
    url: '/storefront/products/accessories/{id}',
    ...options
  })

/**
 * Get Products with comparable data
 */
export const getComparison = <ThrowOnError extends boolean = false>(
  options: Options<GetComparisonData, ThrowOnError>
): RequestResult<unknown, GetComparisonErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, GetComparisonErrors, ThrowOnError>({
    url: '/storefront/product-comparison',
    ...options
  })

/**
 * Get the store's settings
 */
export const settings = <ThrowOnError extends boolean = false>(
  options?: Options<SettingsData, ThrowOnError>
): RequestResult<SettingsResponses, SettingsErrors, ThrowOnError> =>
  (options?.client ?? client).get<SettingsResponses, SettingsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/portalsettings',
    ...options
  })

/**
 * Get all orders
 */
export const getOrders = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrdersData, ThrowOnError>
): RequestResult<GetOrdersResponses, GetOrdersErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetOrdersResponses, GetOrdersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/orders',
    ...options
  })

/**
 * Delete prepared order
 *
 * Delete the prepared order identified by the id provided as path variable.  Returns id of deleted order.
 */
export const deletePreparedOrder = <ThrowOnError extends boolean = false>(
  options: Options<DeletePreparedOrderData, ThrowOnError>
): RequestResult<DeletePreparedOrderResponses, DeletePreparedOrderErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeletePreparedOrderResponses,
    DeletePreparedOrderErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/{orderId}',
    ...options
  })

/**
 * Get order
 */
export const getOrder = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderData, ThrowOnError>
): RequestResult<unknown, GetOrderErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, GetOrderErrors, ThrowOnError>({
    url: '/storefront/orders/{orderId}',
    ...options
  })

/**
 * Update topi order
 */
export const updateTopiOrder = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTopiOrderData, ThrowOnError>
): RequestResult<unknown, UpdateTopiOrderErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, UpdateTopiOrderErrors, ThrowOnError>({
    url: '/storefront/orders/{orderId}/topi',
    ...options
  })

/**
 * Get order history
 *
 * Get the history of all transactions of an order. Sorted from new to old.
 */
export const getTransactionHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetTransactionHistoryData, ThrowOnError>
): RequestResult<GetTransactionHistoryResponses, GetTransactionHistoryErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetTransactionHistoryResponses,
    GetTransactionHistoryErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/{id}/history',
    ...options
  })

/**
 * Get order document
 */
export const getDataHtmlDatasheet2 = <ThrowOnError extends boolean = false>(
  options: Options<GetDataHtmlDatasheet2Data, ThrowOnError>
): RequestResult<unknown, GetDataHtmlDatasheet2Errors, ThrowOnError> =>
  (options.client ?? client).get<unknown, GetDataHtmlDatasheet2Errors, ThrowOnError>({
    url: '/storefront/orders/{id}/documents',
    ...options
  })

/**
 * Get order document for transaction
 */
export const getDataHtmlDatasheet3 = <ThrowOnError extends boolean = false>(
  options: Options<GetDataHtmlDatasheet3Data, ThrowOnError>
): RequestResult<unknown, GetDataHtmlDatasheet3Errors, ThrowOnError> =>
  (options.client ?? client).get<unknown, GetDataHtmlDatasheet3Errors, ThrowOnError>({
    url: '/storefront/orders/{id}/documents/{transactionId}',
    ...options
  })

/**
 * Search for orders
 */
export const searchForOrders = <ThrowOnError extends boolean = false>(
  options: Options<SearchForOrdersData, ThrowOnError>
): RequestResult<SearchForOrdersResponses, SearchForOrdersErrors, ThrowOnError> =>
  (options.client ?? client).get<SearchForOrdersResponses, SearchForOrdersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/orders/search',
    ...options
  })

/**
 * Get all order previews
 */
export const getOrderPreviews = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrderPreviewsData, ThrowOnError>
): RequestResult<GetOrderPreviewsResponses, GetOrderPreviewsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetOrderPreviewsResponses, GetOrderPreviewsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/orders/preview',
    ...options
  })

/**
 * Get all OrderLimitUsers
 */
export const readOrderLimitUsers = <ThrowOnError extends boolean = false>(
  options?: Options<ReadOrderLimitUsersData, ThrowOnError>
): RequestResult<ReadOrderLimitUsersResponses, ReadOrderLimitUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ReadOrderLimitUsersResponses,
    ReadOrderLimitUsersErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/limits/users',
    ...options
  })

/**
 * Get all approvers
 */
export const readApprovers = <ThrowOnError extends boolean = false>(
  options?: Options<ReadApproversData, ThrowOnError>
): RequestResult<ReadApproversResponses, ReadApproversErrors, ThrowOnError> =>
  (options?.client ?? client).get<ReadApproversResponses, ReadApproversErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/orders/limits/approvers',
    ...options
  })

/**
 * Dynamic filters for product search with the provided search term.
 */
export const getFilterNodes = <ThrowOnError extends boolean = false>(
  options?: Options<GetFilterNodesData, ThrowOnError>
): RequestResult<GetFilterNodesResponses, GetFilterNodesErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetFilterNodesResponses, GetFilterNodesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/orders/filters',
    ...options
  })

/**
 * Get ordering conditions
 *
 * Get the history of all transactions of an order. Sorted from new to old.
 */
export const getTransactionHistory1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetTransactionHistory1Data, ThrowOnError>
): RequestResult<GetTransactionHistory1Responses, GetTransactionHistory1Errors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetTransactionHistory1Responses,
    GetTransactionHistory1Errors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/conditions',
    ...options
  })

/**
 * Get all approvable orders
 */
export const getApprovableOrders = <ThrowOnError extends boolean = false>(
  options?: Options<GetApprovableOrdersData, ThrowOnError>
): RequestResult<GetApprovableOrdersResponses, GetApprovableOrdersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApprovableOrdersResponses,
    GetApprovableOrdersErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/approvables',
    ...options
  })

/**
 * Dynamic filters for product search with the provided search term.
 */
export const getApprovableOrdersFilterNodes = <ThrowOnError extends boolean = false>(
  options?: Options<GetApprovableOrdersFilterNodesData, ThrowOnError>
): RequestResult<
  GetApprovableOrdersFilterNodesResponses,
  GetApprovableOrdersFilterNodesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApprovableOrdersFilterNodesResponses,
    GetApprovableOrdersFilterNodesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/orders/approvables/filters',
    ...options
  })

/**
 * Create eprocurement order html
 *
 * Generates html to send the quote back to the eprocurement system. Order permission and punchout session is necessary.
 */
export const sendQuoteEprocurement = <ThrowOnError extends boolean = false>(
  options: Options<SendQuoteEprocurementData, ThrowOnError>
): RequestResult<unknown, SendQuoteEprocurementErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, SendQuoteEprocurementErrors, ThrowOnError>({
    url: '/storefront/order/actions/send-quote-eprocurement',
    ...options
  })

/**
 * Create eprocurement order html for supplier cart
 *
 * Generates html to send the order back to the eprocurement system. Order permission and punchout session is necessary.
 */
export const sendCartEprocurement = <ThrowOnError extends boolean = false>(
  options?: Options<SendCartEprocurementData, ThrowOnError>
): RequestResult<unknown, SendCartEprocurementErrors, ThrowOnError> =>
  (options?.client ?? client).get<unknown, SendCartEprocurementErrors, ThrowOnError>({
    url: '/storefront/order/actions/send-cart-eprocurement',
    ...options
  })

/**
 * Load all product classes
 */
export const getProductClasses = <ThrowOnError extends boolean = false>(
  options?: Options<GetProductClassesData, ThrowOnError>
): RequestResult<GetProductClassesResponses, GetProductClassesErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetProductClassesResponses,
    GetProductClassesErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/cto/productclasses',
    ...options
  })

/**
 * Load all product classes for sku
 */
export const getProductClass = <ThrowOnError extends boolean = false>(
  options?: Options<GetProductClassData, ThrowOnError>
): RequestResult<GetProductClassResponses, GetProductClassErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetProductClassResponses, GetProductClassErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/cto/productclasses/**',
    ...options
  })

/**
 * Load all model groups for product class id
 */
export const getModelGroups = <ThrowOnError extends boolean = false>(
  options: Options<GetModelGroupsData, ThrowOnError>
): RequestResult<GetModelGroupsResponses, GetModelGroupsErrors, ThrowOnError> =>
  (options.client ?? client).get<GetModelGroupsResponses, GetModelGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/cto/modelgroup/{productClassId}',
    ...options
  })

/**
 * Get filters applicable to collections.
 *
 * Sort options = DATE_ASC, DATE_DESC, LAST_MODIFIED, TITLE_DESC, TITLE_ASC
 */
export const getCollectionFilters = <ThrowOnError extends boolean = false>(
  options?: Options<GetCollectionFiltersData, ThrowOnError>
): RequestResult<GetCollectionFiltersResponses, GetCollectionFiltersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetCollectionFiltersResponses,
    GetCollectionFiltersErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/collections/filters',
    ...options
  })

/**
 * Get checkout information for all carts
 */
export const getCheckout = <ThrowOnError extends boolean = false>(
  options?: Options<GetCheckoutData, ThrowOnError>
): RequestResult<GetCheckoutResponses, GetCheckoutErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetCheckoutResponses, GetCheckoutErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/checkout',
    ...options
  })

/**
 * Get checkout information for supplier cart
 */
export const getCheckoutById = <ThrowOnError extends boolean = false>(
  options: Options<GetCheckoutByIdData, ThrowOnError>
): RequestResult<GetCheckoutByIdResponses, GetCheckoutByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<GetCheckoutByIdResponses, GetCheckoutByIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/checkout/{id}',
    ...options
  })

/**
 * Get checkout information for quote
 */
export const getCheckoutForQuote = <ThrowOnError extends boolean = false>(
  options: Options<GetCheckoutForQuoteData, ThrowOnError>
): RequestResult<GetCheckoutForQuoteResponses, GetCheckoutForQuoteErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetCheckoutForQuoteResponses,
    GetCheckoutForQuoteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/storefront/checkout/quote/{id}',
    ...options
  })

/**
 * Get checkout terms
 */
export const getCheckoutTerms = <ThrowOnError extends boolean = false>(
  options?: Options<GetCheckoutTermsData, ThrowOnError>
): RequestResult<GetCheckoutTermsResponses, GetCheckoutTermsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetCheckoutTermsResponses, GetCheckoutTermsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/checkout-terms',
    ...options
  })

/**
 * Get category tree
 */
export const categoryTree = <ThrowOnError extends boolean = false>(
  options?: Options<CategoryTreeData, ThrowOnError>
): RequestResult<CategoryTreeResponses, CategoryTreeErrors, ThrowOnError> =>
  (options?.client ?? client).get<CategoryTreeResponses, CategoryTreeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/categories',
    ...options
  })

/**
 * Get all supplierCarts
 */
export const readLineItems = <ThrowOnError extends boolean = false>(
  options?: Options<ReadLineItemsData, ThrowOnError>
): RequestResult<ReadLineItemsResponses, ReadLineItemsErrors, ThrowOnError> =>
  (options?.client ?? client).get<ReadLineItemsResponses, ReadLineItemsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts',
    ...options
  })

/**
 * Get cart items for supplierCartId
 */
export const readSupplierCart = <ThrowOnError extends boolean = false>(
  options: Options<ReadSupplierCartData, ThrowOnError>
): RequestResult<ReadSupplierCartResponses, ReadSupplierCartErrors, ThrowOnError> =>
  (options.client ?? client).get<ReadSupplierCartResponses, ReadSupplierCartErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/{supplierCartId}',
    ...options
  })

/**
 * Get available optimization strategies
 */
export const getOptimizations = <ThrowOnError extends boolean = false>(
  options?: Options<GetOptimizationsData, ThrowOnError>
): RequestResult<GetOptimizationsResponses, GetOptimizationsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetOptimizationsResponses, GetOptimizationsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/optimizations',
    ...options
  })

/**
 * Get optimization preview for any strategy available
 */
export const getOptimization = <ThrowOnError extends boolean = false>(
  options?: Options<GetOptimizationData, ThrowOnError>
): RequestResult<GetOptimizationResponses, GetOptimizationErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetOptimizationResponses, GetOptimizationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/optimizations/preview',
    ...options
  })

/**
 * Get cart item move info
 *
 * Gives a map of cart item serials to supplier cart serials indication where the cart item can be moved to
 */
export const getMoveInfo = <ThrowOnError extends boolean = false>(
  options?: Options<GetMoveInfoData, ThrowOnError>
): RequestResult<GetMoveInfoResponses, GetMoveInfoErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetMoveInfoResponses, GetMoveInfoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/items/move',
    ...options
  })

/**
 * Get supplier cart items count for supplierCartId, or count of cart if none is passed
 */
export const countLineItems = <ThrowOnError extends boolean = false>(
  options?: Options<CountLineItemsData, ThrowOnError>
): RequestResult<CountLineItemsResponses, CountLineItemsErrors, ThrowOnError> =>
  (options?.client ?? client).get<CountLineItemsResponses, CountLineItemsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/carts/items/count',
    ...options
  })

/**
 * Get the store's branding information
 *
 * Contains information and images that can be used to fill the login page. Does not need authorization.
 */
export const branding = <ThrowOnError extends boolean = false>(
  options?: Options<BrandingData, ThrowOnError>
): RequestResult<BrandingResponses, BrandingErrors, ThrowOnError> =>
  (options?.client ?? client).get<BrandingResponses, BrandingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/storefront/branding',
    ...options
  })
